import { MagnifyingGlassIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Paginator } from "primereact/paginator";

import { SetupTable } from "../SetupPage";

const addButtonClass =
  "inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-[#2563EB] bg-[#2563EB] px-3.5 text-sm font-semibold text-white shadow-sm transition hover:border-[#1D4ED8] hover:bg-[#1D4ED8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2563EB]";

export default function LocationResourcePanel({
  description,
  searchPlaceholder,
  searchRef,
  onSearch,
  addLabel,
  onAdd,
  loading,
  columns,
  emptyText,
  children,
  first,
  rows,
  totalRecords,
  onPageChange,
}) {
  return (
    <div>
      {description ? (
        <p className="border-b border-[#E2E8F0] px-5 py-4 text-sm leading-6 text-[#64748B] sm:px-6">
          {description}
        </p>
      ) : null}

      <div className="grid gap-3 border-b border-[#E2E8F0] px-5 py-4 sm:px-6 lg:grid-cols-[minmax(280px,420px)_1fr] lg:items-center">
        <div className="flex h-11 overflow-hidden rounded-xl border border-[#E2E8F0] bg-white shadow-sm focus-within:border-[#2563EB] focus-within:ring-2 focus-within:ring-[#2563EB]/10">
          <span className="inline-flex items-center pl-3 text-[#64748B]/70">
            <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
          </span>
          <input
            type="search"
            className="h-full w-full border-0 bg-transparent px-3 text-sm text-[#0F172A] placeholder:text-[#64748B]/70 focus:outline-none focus:ring-0"
            placeholder={searchPlaceholder}
            ref={searchRef}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch();
            }}
          />
          <button
            type="button"
            onClick={onSearch}
            className="border-l border-[#E2E8F0] px-4 text-sm font-semibold text-[#0F172A] transition hover:bg-[#F6F8FB] hover:text-[#2563EB]"
          >
            Search
          </button>
        </div>
        <div className="flex flex-wrap gap-2 lg:justify-end">
          <button type="button" onClick={onAdd} className={addButtonClass}>
            <PlusIcon className="h-4 w-4" aria-hidden="true" />
            {addLabel}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="space-y-3 p-5">
          <div className="h-4 w-44 animate-pulse rounded bg-[#E2E8F0]" />
          <div className="h-11 animate-pulse rounded-xl bg-[#EFF6FF]" />
          <div className="h-11 animate-pulse rounded-xl bg-[#EFF6FF]" />
        </div>
      ) : (
        <SetupTable columns={columns} emptyText={emptyText}>
          {children}
        </SetupTable>
      )}

      <div className="flex justify-end px-5 pb-4 pt-2 sm:px-6">
        <Paginator
          first={first}
          rows={rows}
          totalRecords={totalRecords}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
}
